import React from 'react'
import cx from 'classnames'

import NavigationBarFlyout from './NavigationBarFlyout'

import { TNavItem } from '../../../../types/mainNavigation'
import { appendNavParameter } from '../../../../utils/buildUrlFromSuggestion'

const NavigationBarItem: React.FC<
  TNavItem & {
    onClick: (e: React.MouseEvent) => void
    isActive: boolean
    index: number
    isFirst: boolean
    isLast: boolean
  }
> = (props) => {
  return (
    <li
      className={cx('border-b-2 transition-colors duration-150', {
        'ml-0': props.index === 0,
        'mr-0': props.isLast,
        'border-brand-orange': props.isActive,
        'border-transparent': !props.isActive,
        'text-sale-red': props.isHighlight,
      })}
      onClick={!props.isExternal ? props.onClick : undefined}
    >
      <a
        className="flex items-center cursor-pointer"
        href={props.isExternal ? appendNavParameter(props.url) : undefined}
        id={props.trackingId}
      >
        {props.label}
      </a>
      <NavigationBarFlyout {...props} />
    </li>
  )
}

export default NavigationBarItem
